<template>
  <div class="laporan" :class="{ 'animate-flicker': loading }">
    <div>
      <h2>{{ $route.params.id < 0 ? "Tambah" : "Ubah" }} User</h2>

      <br />

      <div class="form-wrapper">
        <form @submit.prevent="save">
          <div class="form-group">
            <label>Nama</label>
            <input type="text" v-model="data.nama" />
          </div>
          <div class="form-group">
            <label>Email</label>
            <input type="email" v-model="data.username" />
          </div>
          <div class="form-group">
            <label>No HP</label>
            <input
              type="tel"
              v-model="data.no_telp"
              placeholder="Gunakan format 08.."
              @keyup="validateNoHp"
            />
            <span v-if="noHpInvalid" style="font-size: 12px; color: red"
              >Gunakan format 08</span
            >
          </div>
          <div class="form-group">
            <label>Akses</label>
            <select v-model="data.id_hak_akses">
              <option
                :value="item.id"
                v-for="(item, index) in dataAkses"
                :key="index"
              >
                {{ item.nama }}
              </option>
            </select>
          </div>
          <div class="form-group" v-if="$route.params.id < 0">
            <label>Password</label>
            <input
              type="password"
              v-if="$route.params.id < 0"
              v-model="data.password"
            />
            <input
              type="text"
              v-else
              v-model="data.password"
              placeholder="Klik untuk melihat password"
              @click="showPassword"
            />
          </div>
          <div class="form-group button">
            <button type="submit" class="btn-fill" :disabled="loadingButton">
              Simpan
            </button>
            <button type="button" class="btn-outline" @click="back()">
              Kembali
            </button>
          </div>
        </form>
      </div>
    </div>

    <div class="modal" v-if="modalOpen" @click="closeModal">
      <div class="modal-body">
        <form @submit.prevent="challengePassword">
          <div class="form-group">
            <label>Masukkan password untuk melihat</label>
            <input type="password" ref="pwd" v-model="adminPassword" />
          </div>
          <div>
            <button
              type="submit"
              class="btn-fill"
              :disabled="loadingButtonPassword"
            >
              Lihat Password
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from "../../api/Api";
export default {
  name: "BahanBakuForm",
  components: {},
  data() {
    return {
      loading: false,
      loadingButton: false,
      loadingButtonPassword: false,
      data: {},
      dataAkses: [],
      noHpInvalid: false,
      hoveredDivisiIndex: -1,
      openAutocomplete: false,
      modalOpen: false,
      rawPassword: "",
      adminPassword: "",
    };
  },
  methods: {
    loadAkses() {
      this.loading = true;

      api
        .get(
          "/v4/setting/user-akses?id_toko=" +
            this.$toko.id +
            "&tipe=DESKTOP"
        )
        .then((r) => {
          this.dataAkses = r.data;

          if (this.$route.params.id > 0) {
            this.loadData();
          } else {
            this.loading = false;
          }
        });
    },
    loadData() {
      this.loading = true;
      api
        .get(
          "/v4/setting/user?id=" +
            this.$route.params.id +
            "&id_toko=" +
            this.$toko.id
        )
        .then((r) => {
          this.loading = false;
          this.data = r.data;
          this.rawPassword = r.data.password;

          console.log(this.data)

          delete this.data.password;
        })
        .catch((e) => {
          this.loading = false;
          this.$toast("Gagal mengambil data");
        });
    },
    save() {
      if (!this.data.nama || !this.data.username || !this.data.no_telp || !this.data.id_hak_akses) {
        console.log(this.data.id_hak_akses)
        this.$toast("Lengkapi datanya dulu ya");
        return;
      }

      this.loadingButton = true;

      this.data.id = this.$route.params.id;
      this.data.id_toko = this.$toko.id;

      api
        .post("/v4/setting/user/save", this.data)
        .then((r) => {
          this.loadingButton = false;

          if (r.valid) {
            this.$router.go(-1);
          } else {
            this.$toast(r.message);
          }
        })
        .catch((e) => {
          this.loadingButton = false;
          this.$toast("Gagal menyimpan data");
        });
    },
    back() {
      this.$router.go(-1);
    },
    validateNoHp() {
      if (this.data.no_telp.match(/[08]{2}/)) {
        this.noHpInvalid = false;
      } else {
        this.noHpInvalid = true;
      }
    },
    chooseDivisi(e) {
      if (this.data.divisi && this.dataDivisi.length > 0) {
        this.openAutocomplete = true;
      } else {
        this.openAutocomplete = false;
      }

      if (e.keyCode == 40) {
        if (this.hoveredDivisiIndex < this.dataDivisi.length - 1) {
          this.hoveredDivisiIndex = this.hoveredDivisiIndex + 1;
        }
      } else if (e.keyCode == 38) {
        if (this.hoveredDivisiIndex > 0) {
          this.hoveredDivisiIndex = this.hoveredDivisiIndex - 1;
        }
      } else if (e.keyCode == 13) {
        e.stopPropagation();
        this.selectDivisi(this.hoveredDivisiIndex);
      }
    },
    selectDivisi(index) {
      this.data.divisi = this.dataDivisi[index];
      this.openAutocomplete = false;
    },
    challengePassword() {
      this.loadingButtonPassword = true;
      api
        .post("/v1/user/challenge-password", {
          id: this.$user.id,
          password: this.adminPassword,
          raw_password: this.rawPassword,
        })
        .then((r) => {
          this.loadingButtonPassword = false;
          if (r.valid) {
            this.data.password = r.data.password;
            this.modalOpen = false;
          } else {
            this.$toast(r.message);
          }
        })
        .catch((e) => {
          this.loadingButtonPassword = false;
          this.$toast("Gagal mengambil data");
        });
    },
    showPassword() {
      if (this.data.password) {
        return;
      }
      if (this.$route.params.id > 0) {
        this.modalOpen = true;
        setTimeout(() => {
          this.$refs["pwd"].focus();
        }, 150);
      }
    },
    closeModal(e) {
      if (e.target.classList[0] == "modal") {
        this.modalOpen = false;
      }
    },
  },
  mounted() {
    this.loadAkses();
  },
};
</script>

<style scoped lang="scss">
.laporan {
  > div {
    margin: 20px;
  }
  h2 {
    margin: 0;
    padding-bottom: 10px;
    border-bottom: 1px solid #ccc;
  }

  .form-wrapper {
    margin-top: 30px;
    form {
      width: 450px;
      .form-group.button {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 15px;
      }
      .autocomplete {
        position: relative;
        .autocomplete-option {
          position: absolute;
          background-color: #fff;
          border: 1px solid #ccc;
          box-shadow: 0px 2px 3px #ccc;
          border-radius: 5px;
          width: 100%;
          margin-top: 10px;
          ul {
            list-style-type: none;
            padding: 0;
            margin: 0;
            li {
              padding: 10px;
              font-size: 14px;
              border-bottom: 1px solid #ccc;
              &.active {
                background-color: var(--primary);
                color: #fff;
              }
            }
          }
        }
      }
    }
  }
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    margin: 0;
    background-color: rgba(0, 0, 0, 0.5);
    .modal-body {
      background: #fff;
      padding: 15px;
      height: 130px;
      margin-top: 100px;
      border-radius: 10px;
      label {
        font-size: 14px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Pengaturan/UserForm.vue